import { render, staticRenderFns } from "./SystemHistoryPage.vue?vue&type=template&id=4ff32262&"
import script from "./SystemHistoryPage.vue?vue&type=script&lang=js&"
export * from "./SystemHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports